import { useEffect } from "react";

export default function ServiceSchema({ service }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-testid", "service-schema");
    script.textContent = JSON.stringify({ "@context": "https://schema.org", ...service });
    document.head.appendChild(script);
    return () => script.remove();
  }, [service]);
  return null;
}
